import React, { useEffect, useState, useRef } from "react";
import { Colors, Constants, Fonts, Images } from "../../config";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Text,
  ScrollView,
} from "react-native-web";
import { useTranslation } from "react-i18next";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import { CImage, IconizedButton, StatusBar } from "../../components/atoms";
import NavigationView from "./components/NavigationView";
import { ArtistDao, CategoryDao, FestivalDao, ProfileDao } from "../../DAO";
import { LocationModal, MultipleCheckModal } from "../../components/molecules";
import moment from "moment";
import { useRouter } from "next/router";
import { venueFilterCriteria } from "./data/venue";
import { rooftopFilterCriteria } from "./data/rooftop";
import { venueCocktailFilterCriteria } from "./data/venue_cocktail";
import { eventFilterCriteria } from "./data/event";
import { festivalFilterCriteria } from "./data/festival";
import { artistFilterCriteria } from "./data/artist";
import { promoterFilterCriteria } from "./data/promoter";
import { otherFilterCriteria } from "./data/other";
import { spaFilterCriteria } from "./data/spa";
import { venueBeachfulFilterCriteria } from "./data/venue_beachful";
import { prefabCompanyFilterCriteria } from "./data/prefab_company";
import { prefabHomeFilterCriteria } from "./data/prefab_home";
import { zooFilterCriteria } from "./data/zoo";
import { animalFilterCriteria } from "./data/animal";
import { parkfulFilterCriteria } from "./data/parkful";
import { casinoFilterCriteria } from "./data/casino";
import { castleFilterCriteria } from "./data/castle";
import { resortFilterCriteria } from "./data/resort";
import { aparthotelFilterCriteria } from "./data/aparthotel";
import { getClass } from "../../helpers/formatHelpers";

const FilterScreen = (props) => {
  const { t } = useTranslation();
  const router = useRouter();
  // const {
  //   category,
  //   isSearch,
  //   keyword,
  //   locationDistance,
  //   locationSelected,
  //   sortBy,
  //   onApply,
  //   filterCriteriaListOriginal,
  //   filterTabSelected,
  // } = props.route?.params;
  const {
    setShowFilter,
    category,
    isSearch,
    keyword,
    // locationDistance,
    locationSelected,
    setLocationSelected,
    // locationDistanceTemp,
    locationSelectedTemp,
    setLocationSelectedTemp,
    sortBy,
    onApply,
    filterCriteriaListOriginal,
    setFilterCriteriaListOriginal,
    filterTabSelected,
    tabList,
    setTabList,
    isMobileVersion,
    isChartsMode,
  } = props;
  const [dataCategory, setDataCategory] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [filterCriteriaSelected, setFilterCriteriaSelected] = useState(null);

  const locationModal = useRef(null);

  const [filterCriteriaList, setFilterCriteriaList] = useState(
    filterCriteriaListOriginal ||
      (category === Constants.categoryType.CATEGORY_VENUE
        ? venueFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_ROOFTOP
        ? rooftopFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_SPA
        ? spaFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_VENUE_BEACHFUL
        ? venueBeachfulFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_PREFAB_COMPANY
        ? prefabCompanyFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_PREFAB_HOMES
        ? prefabHomeFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_ZOO
        ? zooFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_ANIMAL
        ? animalFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_PARKFUL
        ? parkfulFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_CASINO
        ? casinoFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_CASTLE
        ? castleFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_RESORT
        ? resortFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_APARTHOTEL
        ? aparthotelFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_VENUE_COCKTAIL
        ? venueCocktailFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_EVENT
        ? eventFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_FESTIVAL
        ? festivalFilterCriteria(isMobileVersion, styles, isChartsMode)
        : category === Constants.categoryType.CATEGORY_ARTIST
        ? artistFilterCriteria(isMobileVersion, styles, isChartsMode)
        : category === Constants.categoryType.CATEGORY_PROMOTERS
        ? promoterFilterCriteria(isMobileVersion, styles)
        : category === Constants.categoryType.CATEGORY_OTHER
        ? otherFilterCriteria(isMobileVersion, styles)
        : [])
  );

  const subFilterModal = useRef(null);

  const onLoad = () => {
    setIsLoading(true);
    CategoryDao.find().then((categories) => {
      setDataCategory(find(categories, { id: category }));
      setSelectedTabIndex(findIndex(tabList, { id: filterTabSelected }) || 0);
    });
    if (category === Constants.categoryType.CATEGORY_FESTIVAL) {
      let status = [];
      let tagFilters = [];
      let startDateFrom = null;
      let startDateTo = null;
      let rating = null;
      let lineupSize = null;
      let price = null;
      if (filterCriteriaListOriginal) {
        filterCriteriaListOriginal.forEach((item) => {
          if (item.selectedList) {
            if (
              item.isDate &&
              (item.selectedList?.start ||
                item.selectedList?.isUpcoming ||
                item.selectedList?.isAnytime)
            ) {
              if (item.selectedList?.start) {
                startDateFrom = item.selectedList.start;
                startDateTo = item.selectedList.end;
              } else if (item.selectedList?.isUpcoming) {
                startDateFrom = moment().format("YYYY-MM-DD");
                startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              }
            } else if (item.isLineup) {
              lineupSize =
                item.selectedList?.length > 0 ? item.selectedList : null;
            } else if (item.isPrice && item.selectedList.length > 0) {
              price =
                item.selectedList[1] === 1000
                  ? {
                      minValue: item.selectedList[0],
                    }
                  : {
                      minValue: item.selectedList[0],
                      maxValue: item.selectedList[1],
                    };
            } else if (item.isRating && item.selectedList?.length > 0) {
              rating = item.selectedList;
            } else if (item.id === Constants.tagCategory.TAG_CATEGORY_STATUS) {
              status = item.selectedList;
            } else if (item.isAge) {
              if (item.selectedList.length > 0) {
                tagFilters.push({
                  tagId: 1101,
                  category: Constants.tagCategory.TAG_CATEGORY_AGE,
                  maxValue: item.selectedList[1],
                  unit: Constants.tagUnit.TAG_UNIT_AGE,
                });
              }
            } else {
              if (item.selectedList.length > 0) {
                tagFilters.push({
                  category: item.id,
                  tags: item.selectedList,
                });
              }
            }
          }
        });
        tagFilters = JSON.stringify(tagFilters);
      }
      FestivalDao.find({
        startDateFrom,
        startDateTo,
        keyword: keyword,
        pageIndex: 0,
        pageSize: 1,
        status: status.length > 0 ? status : null,
        tagFilters,
        filterFollowLogic: filterTabSelected,
        range:
          locationSelectedTemp?.city_id && locationSelectedTemp?.distance > 0
            ? locationSelectedTemp?.distance
            : null,
        distanceUnit: locationSelectedTemp?.city_id
          ? Constants.distanceUnit.DISTANCE_UNIT_KM
          : null,
        countryId: locationSelectedTemp?.country_id
          ? [locationSelectedTemp?.country_id]
          : null,
        cityId: locationSelectedTemp?.city_id,
        sortType: sortBy,
        rating,
        lineupSize,
        price,
        isFollowCount: 1,
      }).then((result) => {
        const _tabList = tabList;
        _tabList.forEach((item, index) => {
          if (item.title === "All") {
            _tabList[index].count = result.totalCount;
          } else if (item.title === "Followed") {
            _tabList[index].count = result.followingCount;
          } else if (item.title === "Other") {
            _tabList[index].count = result.otherCount;
          }
        });
        setTabList(_tabList);
        setIsLoading(false);
      });
    } else if (category === Constants.categoryType.CATEGORY_ARTIST) {
      let tagFilters = [];
      let countryId = locationSelectedTemp?.country_id
        ? [locationSelectedTemp?.country_id]
        : null;
      let activity = null;
      let startDateFrom = null;
      let startDateTo = null;
      let eventSize = null;
      if (filterCriteriaListOriginal) {
        filterCriteriaListOriginal.forEach((item) => {
          if (item.selectedList) {
            if (
              item.isDate &&
              (item.selectedList?.start ||
                item.selectedList?.isUpcoming ||
                item.selectedList?.isAnytime)
            ) {
              if (item.selectedList?.start) {
                startDateFrom = item.selectedList.start;
                startDateTo = item.selectedList.end;
              } else if (item.selectedList?.isUpcoming) {
                startDateFrom = moment().format("YYYY-MM-DD");
                startDateTo = moment().add(3, "years").format("YYYY-MM-DD");
              }
            } else if (item.isEventSize) {
              eventSize =
                item.selectedList?.length > 0 ? item.selectedList : null;
            } else if (item.isLocation && item.selectedList.length > 0) {
              countryId = item.selectedList;
            } else if (item.isActivity && item.selectedList.length > 0) {
              activity = item.selectedList;
            } else {
              if (item.selectedList.length > 0) {
                tagFilters.push({
                  category: item.id,
                  tags: item.selectedList,
                });
              }
            }
          }
        });
        tagFilters = JSON.stringify(tagFilters);
      }
      ArtistDao.find({
        startDateFrom,
        startDateTo,
        countryId,
        activity,
        keyword: keyword,
        pageIndex: 0,
        tagFilters,
        filterFollowLogic: filterTabSelected,
        pageSize: 1,
        cityId: locationSelectedTemp?.city_id,
        sortType: sortBy,
        eventSize,
        isFollowCount: 1,
      }).then((result) => {
        const _tabList = tabList;
        _tabList.forEach((item, index) => {
          if (item.title === "All") {
            _tabList[index].count = result.totalCount;
          } else if (item.title === "Followed") {
            _tabList[index].count = result.followingCount;
          } else if (item.title === "Other") {
            _tabList[index].count = result.otherCount;
          }
        });
        setTabList(_tabList);
        setIsLoading(false);
      });
    } else if (category === Constants.categoryType.CATEGORY_OTHER) {
      let tagFilters = [];

      if (filterCriteriaListOriginal) {
        filterCriteriaListOriginal.forEach((item) => {
          if (item.selectedList) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList,
              });
            }
          }
        });
        tagFilters = JSON.stringify(tagFilters);
      }
      ProfileDao.find({
        keyword: keyword,
        pageIndex: 0,
        pageSize: 1,
        tagFilters,
        filterFollowLogic: filterTabSelected,
        range:
          locationSelectedTemp?.city_id && locationSelectedTemp?.distance > 0
            ? locationSelectedTemp?.distance
            : null,
        distanceUnit: locationSelectedTemp?.city_id
          ? Constants.distanceUnit.DISTANCE_UNIT_KM
          : null,
        countryId: locationSelectedTemp?.country_id
          ? [locationSelectedTemp?.country_id]
          : null,
        cityId: locationSelectedTemp?.city_id,
        categoryType: 6,
        sortType: sortBy,
        isFollowCount: 1,
      }).then((result) => {
        const _tabList = tabList;
        _tabList.forEach((item, index) => {
          if (item.title === "All") {
            _tabList[index].count = result.totalCount;
          } else if (item.title === "Followed") {
            _tabList[index].count = result.followingCount;
          } else if (item.title === "Other") {
            _tabList[index].count = result.otherCount;
          }
        });
        setTabList(_tabList);
        setIsLoading(false);
      });
    }
  };

  useEffect(() => {
    // onLoad();
  }, [filterTabSelected]);

  useEffect(() => {
    if (filterCriteriaSelected) {
      if (subFilterModal) {
        subFilterModal.current.showModal();
      }
    }
  }, [filterCriteriaSelected]);

  useEffect(() => {
    if (category) {
      const result =
        filterCriteriaListOriginal ||
        (category === Constants.categoryType.CATEGORY_VENUE
          ? venueFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_ROOFTOP
          ? rooftopFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_SPA
          ? spaFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_VENUE_BEACHFUL
          ? venueBeachfulFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_PREFAB_COMPANY
          ? prefabCompanyFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_PREFAB_HOMES
          ? prefabHomeFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_ZOO
          ? zooFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_ANIMAL
          ? animalFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_PARKFUL
          ? parkfulFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_CASINO
          ? casinoFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_CASTLE
          ? castleFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_RESORT
          ? resortFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_APARTHOTEL
          ? aparthotelFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_VENUE_COCKTAIL
          ? venueCocktailFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_EVENT
          ? eventFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_FESTIVAL
          ? festivalFilterCriteria(isMobileVersion, styles, isChartsMode)
          : category === Constants.categoryType.CATEGORY_ARTIST
          ? artistFilterCriteria(isMobileVersion, styles, isChartsMode)
          : category === Constants.categoryType.CATEGORY_PROMOTERS
          ? promoterFilterCriteria(isMobileVersion, styles)
          : category === Constants.categoryType.CATEGORY_OTHER
          ? otherFilterCriteria(isMobileVersion, styles)
          : []);
      setFilterCriteriaList(result);

      setFilterCriteriaListOriginal(result);
    }
  }, [category, filterCriteriaListOriginal]);

  return (
    <div
      style={styles.background}
      className="lg:w-335px sm:w-230px w-full sm:h-auto h-full">
      <View style={styles.background}>
        <StatusBar />
        <NavigationView
          isMobileVersion={isMobileVersion}
          navigation={props.navigation}
          categoryTitle={
            category === Constants.categoryType.CATEGORY_FESTIVAL
              ? "FESTIVALS"
              : category === Constants.categoryType.CATEGORY_EVENT
              ? "EVENTS"
              : category === Constants.categoryType.CATEGORY_ARTIST
              ? "ARTISTS"
              : category === Constants.categoryType.CATEGORY_ROOFTOP
              ? "ROOFTOPS"
              : category === Constants.categoryType.CATEGORY_SPA
              ? "SPAS"
              : category === Constants.categoryType.CATEGORY_VENUE_BEACHFUL
              ? "BEACH CLUBS"
              : category === Constants.categoryType.CATEGORY_PREFAB_COMPANY
              ? "COMPANIES"
              : category === Constants.categoryType.CATEGORY_PREFAB_HOMES
              ? "HOMES"
              : category === Constants.categoryType.CATEGORY_ZOO
              ? "ZOOS"
              : category === Constants.categoryType.CATEGORY_ANIMAL
              ? "ANIMALS"
              : category === Constants.categoryType.CATEGORY_PARKFUL
              ? "PARKS"
              : category === Constants.categoryType.CATEGORY_CASINO
              ? "CASINOS"
              : category === Constants.categoryType.CATEGORY_CASTLE
              ? "CASTLES"
              : category === Constants.categoryType.CATEGORY_RESORT
              ? "RESORTS"
              : category === Constants.categoryType.CATEGORY_APARTHOTEL
              ? "APARTHOTELS"
              : category === Constants.categoryType.CATEGORY_VENUE_COCKTAIL
              ? "BARS"
              : "VENUES"
          }
          onClear={
            isChartsMode
              ? null
              : () => {
                  const newData = filterCriteriaList.map((row) => {
                    return {
                      ...row,
                      selectedList: [],
                    };
                  });
                  setFilterCriteriaList(newData);
                  setFilterCriteriaSelected(null);

                  setShowFilter(false);
                  onApply([], newData, []);
                  if (setLocationSelectedTemp) {
                    setLocationSelectedTemp(null);
                  } else {
                    setLocationSelected(null);
                  }
                }
          }
          onBack={() => setShowFilter(false)}
        />
        <View style={styles.content}>
          {!isLoading && (
            <ScrollView>
              {filterCriteriaList
                .filter((item) => item.isHide === false)
                .map((item, index) =>
                  item.isLocation ? (
                    <TouchableOpacity
                      style={styles.item}
                      onPress={() => locationModal.current.showModal()}>
                      <View style={styles.itemContent}>
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            flex: 1,
                          }}>
                          <CImage
                            source={Images.iconLocationPin}
                            width={isMobileVersion ? 12 : 20}
                            height={isMobileVersion ? 12 : 20}
                            layout="fixed"
                            alt="location"
                            className={
                              category ===
                                Constants.categoryType.CATEGORY_ROOFTOP ||
                              category ===
                                Constants.categoryType.CATEGORY_PARKFUL
                                ? "img-drop-shadow"
                                : ""
                            }
                          />
                          <Text
                            style={[
                              styles.cityLabel,
                              isMobileVersion
                                ? {
                                    fontSize: 12,
                                    lineHeight: 12,
                                    fontFamily: Fonts.primaryRegular,
                                  }
                                : {},
                            ]}>
                            {item?.title}
                          </Text>
                          {((locationSelectedTemp &&
                            (locationSelectedTemp?.country_id ||
                              locationSelectedTemp?.state_id ||
                              locationSelectedTemp?.isWorldWide ||
                              locationSelectedTemp?.isVirtual)) ||
                            (locationSelected &&
                              (locationSelected?.country_id ||
                                locationSelected?.state_id ||
                                locationSelected?.isWorldWide ||
                                locationSelected?.isVirtual))) &&
                            !isChartsMode && (
                              <View style={styles.itemCount}>
                                <Text style={styles.itemCountText}>1</Text>
                              </View>
                            )}
                        </View>
                        {((locationSelectedTemp &&
                          (locationSelectedTemp?.country_id ||
                            locationSelectedTemp?.state_id ||
                            locationSelectedTemp?.isWorldWide ||
                            locationSelectedTemp?.isVirtual)) ||
                          (locationSelected &&
                            (locationSelected?.country_id ||
                              locationSelected?.state_id ||
                              locationSelected?.isWorldWide ||
                              locationSelected?.isVirtual))) &&
                          !isChartsMode &&
                          !isMobileVersion && (
                            <TouchableOpacity
                              style={{
                                paddingVertical: 16,
                                paddingHorizontal:
                                  isChartsMode && isMobileVersion ? 0 : 4,
                              }}
                              onPress={() => {
                                if (!isChartsMode) {
                                  if (setLocationSelectedTemp) {
                                    setLocationSelectedTemp(null);
                                  } else {
                                    setLocationSelected(null);
                                  }
                                }
                              }}>
                              <CImage
                                source={Images.iconClose}
                                width={14}
                                height={14}
                                layout="fixed"
                                alt="close"
                              />
                            </TouchableOpacity>
                          )}

                        {isChartsMode && isMobileVersion && (
                          <TouchableOpacity
                            style={{
                              paddingVertical: 16,
                              paddingHorizontal: isMobileVersion ? 0 : 4,
                            }}
                            onPress={() => {
                              if (!isChartsMode) {
                                if (setLocationSelectedTemp) {
                                  setLocationSelectedTemp(null);
                                } else {
                                  setLocationSelected(null);
                                }
                              }
                            }}>
                            <CImage
                              source={Images.iconAngleRight}
                              width={14}
                              height={14}
                              layout="fixed"
                              alt="close"
                            />
                          </TouchableOpacity>
                        )}
                        {!isChartsMode && isMobileVersion && (
                          <View style={{ width: 12, height: 12 }}>
                            <CImage
                              source={Images.iconAngleRight}
                              width={12}
                              height={12}
                              layout="fixed"
                            />
                          </View>
                        )}
                      </View>
                    </TouchableOpacity>
                  ) : (
                    <TouchableOpacity
                      key={index}
                      style={styles.item}
                      onPress={() => setFilterCriteriaSelected(item)}>
                      <View style={styles.itemContent}>
                        <CImage
                          source={item?.icon}
                          width={
                            isMobileVersion && item?.width > 0
                              ? item?.width - 6
                              : item?.width
                          }
                          height={
                            isMobileVersion && item?.height > 0
                              ? item?.height - 6
                              : item?.height
                          }
                          layout="fixed"
                          alt={item?.title?.toLowerCase()}
                          className={
                            category ===
                              Constants.categoryType.CATEGORY_ROOFTOP ||
                            category === Constants.categoryType.CATEGORY_PARKFUL
                              ? "img-drop-shadow"
                              : ""
                          }
                        />
                        <Text
                          style={[
                            styles.itemTitle,
                            isMobileVersion
                              ? {
                                  fontSize: 12,
                                  lineHeight: 12,
                                  fontFamily: Fonts.primaryRegular,
                                }
                              : [],
                          ]}>
                          {item?.title}
                        </Text>
                        {!isChartsMode && (
                          <>
                            {(item.isDate && item?.selectedList?.start) ||
                            item.selectedList?.isUpcoming ||
                            item.selectedList?.isAnytime ? (
                              <View style={styles.itemCount}>
                                <Text style={styles.itemCountText}>
                                  {item?.selectedList?.start
                                    ? `${item?.selectedList?.start} - ${item?.selectedList?.end}`
                                    : item?.selectedList?.isUpcoming
                                    ? "Upcoming"
                                    : "Anytime"}
                                </Text>
                              </View>
                            ) : (
                              <>
                                {item?.selectedList?.length > 0 && (
                                  <View style={styles.itemCount}>
                                    <Text style={styles.itemCountText}>
                                      {item.isPrice
                                        ? `${
                                            item?.selectedList[0] === 0
                                              ? "Free"
                                              : `$${item?.selectedList[0]}`
                                          } - ${`${
                                            item?.selectedList[1] === 1000
                                              ? "Max"
                                              : `$${item?.selectedList[1]}`
                                          }`}`
                                        : item.isAge
                                        ? `${item?.selectedList[0]} ${item?.selectedList[1]} ${item?.selectedList[2]}`
                                        : item?.selectedList?.length}
                                    </Text>
                                  </View>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </View>
                      {!isChartsMode && (
                        <>
                          {((item.isDate && item?.selectedList?.start) ||
                            item.selectedList?.isUpcoming ||
                            item.selectedList?.isAnytime ||
                            item?.selectedList?.length > 0) &&
                            !isMobileVersion && (
                              <TouchableOpacity
                                style={{
                                  paddingVertical: 16,
                                  paddingHorizontal: 4,
                                }}
                                onPress={() => {
                                  const newData = filterCriteriaList.map(
                                    (row) => {
                                      if (row.title === item.title) {
                                        return {
                                          ...row,
                                          selectedList: [],
                                        };
                                      }
                                      return row;
                                    }
                                  );
                                  setFilterCriteriaList(newData);
                                  setFilterCriteriaSelected(null);

                                  setShowFilter(false);
                                  onApply(
                                    newData
                                      .filter(
                                        (item) =>
                                          item.isHide === false &&
                                          item.selectedList?.length > 0
                                      )
                                      .flatMap((item) => item.selectedList),
                                    newData.filter(
                                      (item) => item.isHide === false
                                    ),
                                    tabList[selectedTabIndex]
                                  );
                                }}>
                                <CImage
                                  source={Images.iconClose}
                                  width={14}
                                  height={14}
                                  layout="fixed"
                                />
                              </TouchableOpacity>
                            )}
                        </>
                      )}
                      {isMobileVersion && (
                        <View style={{ width: 12, height: 12 }}>
                          <CImage
                            source={Images.iconAngleRight}
                            width={12}
                            height={12}
                            layout="fixed"
                          />
                        </View>
                      )}
                    </TouchableOpacity>
                  )
                )}
            </ScrollView>
          )}
        </View>
        <div className="sm:hidden block">
          <View style={styles.footerButton}>
            {!isChartsMode && (
              <View style={styles.footerItemLeft}>
                <IconizedButton
                  buttonTitle={t("key_button_clear_all")}
                  bordered
                  style={{
                    borderColor: getClass("border-black"),
                  }}
                  borderedTextColor={getClass("text-white")}
                  onPress={() => {
                    const newData = filterCriteriaList.map((row) => {
                      return {
                        ...row,
                        selectedList: [],
                      };
                    });
                    setFilterCriteriaList(newData);
                    setFilterCriteriaSelected(null);

                    setShowFilter(false);
                    onApply([], newData, []);
                  }}
                  isMobileVersion={isMobileVersion}
                />
              </View>
            )}
            <View style={styles.footerItemRight}>
              <IconizedButton
                buttonTitle={t("key_button_show")}
                // style={{
                //   backgroundColor:
                //     filterCriteriaList.filter(
                //       (item) =>
                //         item.isHide === false && item.selectedList?.length > 0
                //     ).length !== 3
                //       ? Colors.grayText
                //       : Colors.white,
                // }}
                // filledTextColor={
                //   filterCriteriaList.filter(
                //     (item) =>
                //       item.isHide === false && item.selectedList?.length > 0
                //   ).length !== 3
                //     ? Colors.lightGray
                //     : null
                // }
                filled
                // disabled={
                //   filterCriteriaList.filter(
                //     (item) =>
                //       item.isHide === false && item.selectedList?.length > 0
                //   ).length !== 3
                // }
                filledColor={
                  process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia"
                    ? Colors.zooBlue
                    : process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld"
                    ? Colors.prefabBlack
                    : process.env.NEXT_PUBLIC_APP_NAME == "Parkful"
                    ? Colors.parkfulPink
                    : process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club"
                    ? Colors.resortPink
                    : process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia"
                    ? Colors.castleBlack
                    : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
                    ? Colors.rooftopPink
                    : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
                    ? Colors.spaBlue
                    : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
                    ? Colors.beachPink
                    : null
                }
                filledTextColor={
                  process.env.NEXT_PUBLIC_APP_NAME == "Zoopedia" ||
                  process.env.NEXT_PUBLIC_APP_NAME == "PrefabWorld" ||
                  process.env.NEXT_PUBLIC_APP_NAME == "Parkful" ||
                  process.env.NEXT_PUBLIC_APP_NAME == "LuxResort Club" ||
                  process.env.NEXT_PUBLIC_APP_NAME == "Castlepedia" ||
                  process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub" ||
                  process.env.NEXT_PUBLIC_APP_NAME == "SpaClub" ||
                  process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
                    ? Colors.white
                    : null
                }
                onPress={() => {
                  setShowFilter(false);
                  if (locationSelectedTemp) {
                    setLocationSelected(locationSelectedTemp);
                  }
                  onApply(
                    filterCriteriaList
                      .filter(
                        (item) =>
                          item.isHide === false && item.selectedList?.length > 0
                      )
                      .flatMap((item) => item.selectedList),
                    filterCriteriaList.filter((item) => item.isHide === false),
                    tabList[selectedTabIndex]
                  );
                }}
                isMobileVersion={isMobileVersion}
              />
            </View>
          </View>
        </div>
        <MultipleCheckModal
          ref={subFilterModal}
          icon={filterCriteriaSelected?.icon}
          iconWidth={
            filterCriteriaSelected?.title === "Country"
              ? isMobileVersion
                ? 19.5 - 6
                : 19.5
              : filterCriteriaSelected?.title === "Activity"
              ? isMobileVersion
                ? 21 - 6
                : 19.5
              : filterCriteriaSelected?.title === "Rating"
              ? isMobileVersion
                ? 25 - 6
                : 25.5
              : null
          }
          category={category}
          title={filterCriteriaSelected?.title}
          checkedItemIds={filterCriteriaSelected?.selectedList || []}
          isPrice={filterCriteriaSelected?.isPrice || false}
          isAge={filterCriteriaSelected?.isAge || false}
          isDimension={filterCriteriaSelected?.isDimension || false}
          isSearchable={filterCriteriaSelected?.isSearchable || false}
          isDate={filterCriteriaSelected?.isDate || false}
          isLineup={filterCriteriaSelected?.isLineup || false}
          isRangeValue={filterCriteriaSelected?.isRangeValue || false}
          isEventSize={filterCriteriaSelected?.isEventSize || false}
          isCompanyHomeSize={filterCriteriaSelected?.isCompanyHomeSize || false}
          isCountry={filterCriteriaSelected?.isCountry || false}
          isRating={filterCriteriaSelected?.isRating || false}
          isMinimumOneSelect={
            filterCriteriaSelected?.isMinimumOneSelect || false
          }
          isSingle={filterCriteriaSelected?.isSingle || false}
          dateType={filterCriteriaSelected?.dateType || false}
          items={filterCriteriaSelected?.detailList || []}
          onClose={() => {
            setFilterCriteriaSelected(null);
            if (subFilterModal) {
              subFilterModal.current.hideModal();
            }
          }}
          buttonTitleClear={isChartsMode ? t("key_close") : null}
          onPressClear={() => {
            if (isChartsMode) {
              setFilterCriteriaSelected(null);
              if (subFilterModal) {
                subFilterModal.current.hideModal();
              }
            } else {
              const newData = filterCriteriaList.map((item) => {
                if (item.title === filterCriteriaSelected?.title) {
                  return {
                    ...item,
                    selectedList: [],
                  };
                }
                return item;
              });
              setFilterCriteriaList(newData);
              setFilterCriteriaSelected(null);

              if (!isMobileVersion) {
                onApply(
                  newData
                    .filter(
                      (item) =>
                        item.isHide === false && item.selectedList?.length > 0
                    )
                    .flatMap((item) => item.selectedList),
                  newData.filter((item) => item.isHide === false),
                  tabList[selectedTabIndex]
                );
              }
              if (subFilterModal) {
                subFilterModal.current.hideModal();
              }
            }
          }}
          onPressItem={(items) => {
            const newData = filterCriteriaList.map((item) => {
              if (item.title === filterCriteriaSelected?.title) {
                return {
                  ...item,
                  selectedList: items,
                };
              }
              return item;
            });
            setFilterCriteriaList(newData);
            setFilterCriteriaSelected(null);
            if (subFilterModal) {
              subFilterModal.current.hideModal();
            }
            onApply(
              newData
                .filter(
                  (item) =>
                    item.isHide === false && item.selectedList?.length > 0
                )
                .flatMap((item) => item.selectedList),
              newData.filter((item) => item.isHide === false),
              tabList[selectedTabIndex]
            );
          }}
          isMobileVersion={isMobileVersion}
        />
      </View>
      <LocationModal
        ref={locationModal}
        category={category}
        locationSelected={locationSelectedTemp}
        distanceValue={locationSelectedTemp?.distance}
        isDistance
        isCountryOnly={isChartsMode}
        isShowState={!isChartsMode}
        onPressApply={(location, distance) => {
          router.replace({
            query: { ...router.query, page: 1 },
          });
          if (setLocationSelectedTemp) {
            setLocationSelectedTemp({ ...location, distance });
          } else {
            setLocationSelected({ ...location, distance });
          }
          if (locationModal) {
            locationModal.current.hideModal();
          }
        }}
        onPressCancel={() => {
          if (locationModal) {
            locationModal.current.hideModal();
          }
        }}
        isMobileVersion={isMobileVersion}
      />
    </div>
  );
};

const styles = StyleSheet.create({
  background: {
    flex: 1,
    backgroundColor: getClass("background"),
    overflow: "auto",
    height: "100%",
  },
  container: {
    flex: 1,
    alignItems: "center",
  },
  content: {
    flex: 1,
    padding: 16,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 4,
  },
  icon: {
    width: 16,
    height: 16,
    resizeMode: "contain",
    marginRight: 6,
  },
  item: {
    backgroundColor: getClass("bg-gray1"),
    borderRadius: 50,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 12,
    paddingHorizontal: 18,
    marginBottom: 8,
    height: 40,
  },
  itemContent: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  itemTitle: {
    fontFamily: Fonts.primarySemiBold,
    color: Colors.white,
    fontSize: 14,
    lineHeight: 14,
    marginLeft: 8,
  },
  cityLabel: {
    color: Colors.white,
    fontSize: 14,
    lineHeight: 14,
    marginLeft: 6,
    fontFamily: Fonts.primarySemiBold,
  },
  countryLabel: {
    color: Colors.placeholder,
    fontSize: 14,
    lineHeight: 14,
    marginLeft: 4,
    fontFamily: Fonts.primarySemiBold,
  },
  itemCount: {
    backgroundColor: Colors.tabBottomColor,
    borderRadius: 50,
    paddingHorizontal: 8,
    paddingVertical: 3,
    marginLeft: 12,
  },
  itemCountText: {
    fontFamily: Fonts.primaryRegular,
    color: Colors.white,
    fontSize: 12,
    lineHeight: 12,
  },
  gap: {
    height: 40,
  },
  footerButton: {
    backgroundColor: getClass("background"),
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
  },
  footerItemLeft: {
    flex: 0.6,
    paddingRight: 16,
  },
  footerItemRight: {
    flex: 1,
  },
});

export default FilterScreen;
